import {
  DocumentEntryTypename,
  type DirectoryEntryIF,
} from '../../../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentIndexRpc';

import type { DocumentSearchResultType } from './DocumentsApi';

// TODO(SalesDocumentsCHIRPMigration cleanup): delete this file along with DocumentSearchResultType;
// consumers should read DocumentEntry fields directly after filtering on __typename
export const mapDocumentEntry = (
  entry: DirectoryEntryIF
): DocumentSearchResultType | null => {
  if (entry.__typename !== DocumentEntryTypename) return null;
  return {
    contentId: entry.id,
    name: entry.name,
    documentId: String(entry.id),
    brandId: entry.brandId ?? null,
    // TODO: map isLegalConsentEnabled when included in DirectoryEntryIF
    legalConsentEnabled: null,
    isDownloadable: entry.isDownloadable ?? null,
    metadata: {
      title: entry.name,
      thumbnailUrl: entry.thumbnailUrl ?? '',
      user: {
        firstName: entry.createdBy?.firstName ?? '',
        lastName: entry.createdBy?.lastName ?? '',
        email: entry.createdBy?.email ?? '',
      },
    },
  };
};
